import Image from "next/image";
import Link from "next/link";

import PartnersAndSponsorsLinks from "@/features/partnerAndSponsors/PartnersAndSponsorsLinks";
import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../shared/components/layout";

export default function Associates() {
    return (
        <div>
            <PageSeo title="Associates | The Gender Index" pathname={ROUTES.associates}/>
            <Layout>
                <div className='singleLayout type2 partnersPage'>
                    <h3>Partners and sponsors</h3>
                    <p className='body-default-copy-large'>
                        Thank you to our partners and sponsors who make it possible for The Gender Index to exist,
                        click on the logos below to learn more about why they are supporting The Gender Index.
                    </p>
                    <PartnersAndSponsorsLinks />
                    <div>
                        <ul className="commonList associatesList">
                            <li>
                                <Link href="https://www.cardiff.ac.uk" target="_blank" rel="noreferrer">
                                    <figure>
                                        {/* <img src="/images/Cardiff-University.jpg" alt="associates_image" /> */}
                                        <Image
                                            src="/images/Cardiff-University.jpg"
                                            alt="associates_image"
                                            width={100}
                                            height={96}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>Cardiff university</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        Founded in 1883, Cardiff University is established as one of Britain’s leading research universities.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <Link href="https://www.enterpriseresearch.ac.uk/" target="_blank" rel="noreferrer">
                                    <figure>
                                        {/* <img src="/images/ERC.jpg" alt="associates_image" /> */}
                                        <Image
                                            src="/images/ERC.jpg"
                                            alt="associates_image"
                                            width={100}
                                            height={42}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>ERC</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        The ERC is the UK’s leading centre of excellence for research into the growth, innovation and productivity of
                                        small and medium-sized enterprises (SMEs).
                                    </p>
                                </div>
                            </li>
                            <li>
                                <Link href="https://www.qub.ac.uk" target="_blank" rel="noreferrer">
                                    <figure>
                                        {/* <img src="/images/queens.jpg" alt="associates_image" /> */}
                                        <Image
                                            src="/images/queens.jpg"
                                            alt="associates_image"
                                            width={100}
                                            height={44}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>Queens University Belfast</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        Queen’s University Belfast is one of the leading universities in the UK and Ireland,
                                    </p>
                                </div>
                            </li>
                            <li>
                                <Link href="https://www.strath.ac.uk/" target="_blank" rel="noreferrer">
                                    <figure>
                                        {/* <img src="/images/Strathclyde-University.png" alt="associates_image" /> */}
                                        <Image
                                            src="/images/Strathclyde-University.png"
                                            alt="associates_image"
                                            width={100}
                                            height={120}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>Strathclyde University</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        The University of Strathclyde is a public research university located in Glasgow, Scotland.
                                    </p>
                                </div>
                            </li>
                            {/* <li>
                                <Link href="https://www.greengage.co/" target="_blank" rel="noreferrer">
                                    <figure>
                                        <Image
                                            src="/images/PartnerLogos/greengage.png"
                                            alt="associates_image"
                                            width={100}
                                            height={26}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>Greengage</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        Greengage is the first fully integrated financial services group bridging the traditional financial
                                        services space with the new digital innovations in cryptoassets and blockchain.
                                    ​</p>
                                </div>
                            </li> */}
                            <li>
                                <Link href="https://vividimagination.studio/" target="_blank" rel="noreferrer">
                                    <figure>
                                        <Image
                                            // src="/images/vivid-admin-logo.png"
                                            src="/images/vivid-2026.webp"
                                            alt="associates_image"
                                            width={100}
                                            height={100}
                                            loading="lazy"
                                        />
                                    </figure>
                                </Link>
                                <div className="infoWrap">
                                    <h6>Vivid</h6>
                                    <p className='body-default-copy threeLinerText'>
                                        At Vivid we bring together multiple disciplines to give creative sense to your business or project.
                                        We rationalise the concepts and give form to the ideas, helping to bring your vision to life across multi-platform delivery.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </Layout>
        </div>
    );
}

